import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

interface NewSlideDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (description: string) => void;
  lang: string;
}

function NewSlideDialog({ open, onClose, onSubmit, lang }: NewSlideDialogProps) {
  const [description, setDescription] = useState('');

  const handleClose = () => {
    setDescription('');
    onClose();
  };

  const handleSubmit = () => {
    if (description.trim()) {
      onSubmit(description.trim());
      setDescription('');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {lang === 'en' ? 'Add New Slide' : '添加新幻灯片'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={lang === 'en' ? 'Description of this slide' : '此页描述'}
          fullWidth
          multiline
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder={lang === 'en' 
            ? 'Describe the content for this slide, e.g. This is title slide, or this slide introduce our team' 
            : '描述此页内容，例如：这是标题页，或者此页介绍我们团队'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {lang === 'en' ? 'Cancel' : '取消'}
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!description.trim()}
        >
          {lang === 'en' ? 'Create' : '创建'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewSlideDialog; 